import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function useResponsive() {
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down('sm'));
	const mdDown = useMediaQuery(theme.breakpoints.down('md'));
	const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
	return useMemo(() => ({ smDown, mdDown, lgDown }), [smDown, mdDown, lgDown]);
}
